import { GrowthbookClientProvider } from '@openfeature/growthbook-client-provider';

import { growthBookContext, growthBookInitOptions } from '../environments/environment';

export const growthBookClientProvider = new GrowthbookClientProvider(growthBookContext, growthBookInitOptions);
